// delReportingTab/state.js

export const delReportingTabUIInitialState = {
  showDelForm: false,
};
